//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/MechanicalRouting.js";
import "../no/Builder.js";
let d=[[],[[[],"AddAllRuns",{},0,0],[["runs"],"AddRuns",{},1,0],[["run","revision"],"SetSelectedRunRevision",{},2,0],[["run"],"GetSelectedRunRevision",{R_:{revision:''}},1,0],[["run"],"SetRunToDissociate",{},1,0],[["runIdentifier"],"GetRunStatus",{R_:{status:''}},1,0]],[]];
SPLM.MechanicalRouting.UpdateRunBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.MechanicalRouting.UpdateRunBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.MechanicalRouting.UpdateRunBuilder.Status = Object.freeze({
    "RetainedExistingRevision" : "RetainedExistingRevision", "Dissociated" : "Dissociated", "UpdatedToSelectedRevision" : "UpdatedToSelectedRevision", "UpdatedToLatestRevision" : "UpdatedToLatestRevision"});

export default SPLM;